<template>
  <div class="my-payments-page">
    <div class="my-payments-page__topmatter" :inert="anyMenusOpen">
      <BackButton />
      <div class="page-title">My Payments</div>
      <MyPaymentsHeader :earned="earned" />
      <MyPaymentsAlerts />
    </div>
    <MyInvoices
      @earned="earned = $event"
      :key="`my-invoices-${reloadKey}`"
      @checkUrlParamInvoice="checkUrlParamInvoice($event)"
      @menuEvent="menus.myInvoices = $event"
      @hook:mounted="menus.myInvoices = false"
      :inertProp="anyMenusOpen"
    />
    <v-dialog max-width="700" v-model="dialog">
      <v-card light>
        <v-btn class="dialog-close" icon @click="close()">
          <v-icon>$close</v-icon>
        </v-btn>
        <MyInvoice
          v-if="urlParamInvoice"
          :value="urlParamInvoice.id"
          @refresh="refresh"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MyInvoices from "./my-payments/my-invoices.my-payments";
import MyPaymentsHeader from "./my-payments/header.my-payments";
import MyPaymentsAlerts from "./my-payments/alerts.my-payments";
import MyInvoice from "./my-payments/MyInvoice";
import pageMenuEventBubbler from "@/mixins/menu-event-bubblers/meb-page.mixin.js";

export default {
  name: "MyPaymentsPage",
  mixins: [pageMenuEventBubbler],
  components: {
    MyInvoices,
    MyPaymentsHeader,
    MyPaymentsAlerts,
    MyInvoice,
  },
  head: {
    title: "My Payments",
    titleTemplate: "%s | iU Community",
  },
  data() {
    return {
      earned: null,
      dialog: false,
      urlParamInvoice: null,
      reloadKey: 1,
      menus: {
        myInvoices: false,
      },
    };
  },
  mounted() {
    if (this.$route.query.invoice) {
      this.fetchUrlParamInvoice(this.$route.query.invoice);
    }
  },
  methods: {
    async fetchUrlParamInvoice(id) {
      const { data } = await this.$api.Invoice.get({ id });
      this.urlParamInvoice = data;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$router.replace({ query: null });
    },
    refresh() {
      this.close();
      this.reloadKey++;
    },
    checkUrlParamInvoice(data) {
      if (
        data.payload.invoice_id &&
        data.payload.invoice_id == this.urlParamInvoice?.id
      ) {
        this.fetchUrlParamInvoice(data.payload.invoice_id);
        this.$alert("Invoice updated");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-close {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
